import React, { useState } from 'react'
import Button from 'meinian-package/src/baseComponent/button'
import ChildInspirationDrawer from '../childInspirationDrawer'
import styles from './index.module.less'

export default ({
  data,
  info,
  crateInspirationAuth,
  query
}) => {
  const [visible, setVisible] = useState(false)

  return <div className={styles['mn-child-inspiration']}>
    <Button
      onClick={() => setVisible(true)}
      style={{ marginLeft: '8px' }}
    >
      子灵感集
    </Button>
    <ChildInspirationDrawer
      info={info}
      data={data}
      crateInspirationAuth={crateInspirationAuth}
      query={query}
      visible={visible}
      onClose={() => setVisible(false)}
    />
  </div>
}
